import React, { useState, useRef } from 'react';
import { Box } from 'components';
import { useOnClickOutside } from 'utils';
import { FilterButton } from '.';
import { NoApplyFilterMenu } from './NoApplyFilterMenu';

/**
 * Special filter button for the city filter that uses the NoApplyFilterMenu
 * This removes the extra Apply button since the city filter has its own Apply button
 */
export const CityFilterButton = ({
  label,
  icon,
  children,
  changed,
  onReset,
  Icon,
  ...props
}) => {
  const [open, setOpen] = useState();
  const ref = useRef();

  useOnClickOutside(ref, () => {
    if (open) {
      children && setOpen(false);
    }
  });

  // Handle click on the filter button
  const handleButtonClick = () => {
    if (children) {
      setOpen(!open);
    }
  };

  // Enhance children with closeMenu prop
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      // Pass the setOpen function to allow children to close the menu
      return React.cloneElement(child, { closeMenu: () => setOpen(false) });
    }
    return child;
  });

  return (
    <Box
      ref={ref}
      style={{
        cursor: props.disabled ? 'not-allowed' : 'pointer',
      }}
      position={{ xs: 'none', sm: 'relative' }}
    >
      <FilterButton
        active={open}
        onClick={handleButtonClick}
        onReset={changed ? onReset : null}
        Icon={Icon || null}
        {...props}
      >
        {label}
      </FilterButton>

      {open && (
        <NoApplyFilterMenu flip={props.flip}>
          {childrenWithProps}
        </NoApplyFilterMenu>
      )}
    </Box>
  );
};

export default CityFilterButton;
